import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { FileType } from './file-type.interface';

export class FileTypeService {
   async getFileTypes() {
      const response = await http.get<ApiResource<Array<FileType>>>('file-types');
      return response.data;
   }
}
